// extracted by mini-css-extract-plugin
module.exports = {"wallex__text":"wallex-text_wallex__text____thO"};